import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const DocumentUploadIcon = forwardRef<SVGSVGElement, IconProps>(function DocumentUploadIcon(
  { color = '', width = 13, height = 12, ...rest },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.1879 1.6879C1.69372 2.18207 1.42308 2.99937 1.42308 4.33846V7.66154C1.42308 9.00063 1.69372 9.81793 2.1879 10.3121C2.68207 10.8063 3.49937 11.0769 4.83846 11.0769H8.16154C9.50063 11.0769 10.3179 10.8063 10.8121 10.3121C11.3063 9.81793 11.5769 9.00063 11.5769 7.66154V5.35385H9.82308C8.96674 5.35385 8.24898 5.21708 7.76595 4.73405C7.28292 4.25102 7.14615 3.53326 7.14615 2.67692V0.923077H4.83846C3.49937 0.923077 2.68207 1.19372 2.1879 1.6879ZM8.06923 1.57579L10.9242 4.43077H9.82308C9.01788 4.43077 8.62794 4.29062 8.41866 4.08134C8.20939 3.87206 8.06923 3.48212 8.06923 2.67692V1.57579ZM1.53518 1.03518C2.28716 0.283201 3.40832 0 4.83846 0H7.60769C7.7301 0 7.84749 0.0486262 7.93405 0.135182L12.3648 4.56595C12.4514 4.65251 12.5 4.7699 12.5 4.89231V7.66154C12.5 9.09167 12.2168 10.2128 11.4648 10.9648C10.7128 11.7168 9.59167 12 8.16154 12H4.83846C3.40832 12 2.28716 11.7168 1.53518 10.9648C0.783201 10.2128 0.5 9.09167 0.5 7.66154V4.33846C0.5 2.90832 0.783201 1.78716 1.53518 1.03518ZM3.40441 6.22749L4.5121 5.1198C4.69235 4.93955 4.98458 4.93955 5.16482 5.1198L6.27251 6.22749C6.45275 6.40773 6.45275 6.69996 6.27251 6.8802C6.09227 7.06044 5.80004 7.06044 5.6198 6.8802L5.3 6.56041V8.76923C5.3 9.02413 5.09336 9.23077 4.83846 9.23077C4.58356 9.23077 4.37692 9.02413 4.37692 8.76923V6.56041L4.05713 6.8802C3.87688 7.06044 3.58465 7.06044 3.40441 6.8802C3.22417 6.69996 3.22417 6.40773 3.40441 6.22749Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
